import { Button } from '@mui/material'
import React from 'react'

function BorderContainedBtn({ children, sx = {}, disabled = false, ...rest }) {
  return (
    <Button
      {...rest}
      disabled={disabled}
      sx={{
        textTransform: 'unset',
        borderRadius: '16px',
        ...(!disabled && { border: '1px solid #EE46BC' }),
        background: '#F670C7',
        boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
        '&:hover': {
          ...(!disabled && { border: '1px solid #EE46BC' }),
          background: '#F670C7',
          boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  )
}

export default BorderContainedBtn

export function BorderOutlinedBtn({ children, sx = {}, disabled = false, ...rest }) {
  return (
    <Button
      {...rest}
      disabled={disabled}
      sx={{
        textTransform: 'unset',
        borderRadius: '16px',
        ...(!disabled && { border: '1px solid #D0D5DD' }),
        background: '#FFF',
        boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
        color: '#363F72',
        '&:hover': {
          ...(!disabled && { border: '1px solid #D0D5DD' }),
          background: '#FFF',
          boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
          color: '#363F72',
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  )
}

export function BorderOutlinedBtnSecondary({ children, sx = {}, disabled = false, ...rest }) {
  return (
    <Button
      {...rest}
      disabled={disabled}
      sx={{
        textTransform: 'unset',
        flexShrink: 0,
        borderRadius: '16px',
        ...(!disabled && { border: '1px solid #D0D5DD' }),
        background: '#FFF',
        boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
        '&:hover': {
          ...(!disabled && { border: '1px solid #D0D5DD' }),
          background: '#FFF',
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  )
}

export function TextBtn({ children, sx = {}, disabled = false, ...rest }) {
  return (
    <Button
      {...rest}
      disabled={disabled}
      sx={{
        textTransform: 'unset',
        border: 'none',
        background: '#FFF',
        boxShadow: 'none',
        color: '#363F72',
        '&:hover': {
          border: 'none',
          background: '#FFF',
          boxShadow: 'none',
          color: '#363F72',
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  )
}
